<!--
 * @Author: Huangjiajia
 * @Description: 首页
 * @Date: 2025-02-10 11:52:44
 * @LastEditors: hjj
 * @LastEditTime: 2025-06-11 09:55:41
 * @FilePath: /beiye_project/src/views/home/index.vue
-->
<template>
  <div class="content">
    <div class="banner_box">
      <!-- <img src="@/assets/images/banner.png" alt="" /> -->
      <img src="@/assets/images/home-banner.jpg" alt="" />
      <div class="img_word_box">
        <h1>-- 持续为客户创造价值 --</h1>
        <div class="img_word_box_content">
          <div class="img_word_box_content--top">
            蜜蜂百业商城是由广西万通供应链服务有限公司开发的一个在线购物商城app，是您在线购物的理想之地！我们提供丰富多样的商品，便捷的购物体验，以及快速的送货服务。
          </div>
          <!-- <div class="img_word_box_content--bottom">
            <ul>
              <li>·2020年科技中小企业</li>
              <li>·2020年南宁市纳税信用A级</li>
            </ul>
          </div> -->
        </div>
        <ul class="circle-box">
          <li v-for="(e, i) in imgWordList" :key="i">
            {{e}}
            <img src="@/assets/images/home-circle1.png" alt="" class="outsideCircle" />
          </li>
        </ul>
      </div>
    </div>
    <div class="swiper-slide" v-for="(e, i) in list" :key="i">
      <div class="top_detail">
        <div class="image_contain" v-if="i % 2 != 0">
          <span class="image_line"></span>
          <img :src="e.phoneOutside" alt="" class="screen" />
          <img :src="e.phnoeContain" alt="" class="img_detail" />
          <img :src="e.phoneMask" alt="" class="shap" />
        </div>
        <div class="contain">
          <div class="top_introduce">
            <span class="title">{{ e.topTitle }}</span>
            <span class="describe">{{ e.bigTitle }}</span>
            <span class="objective">
              {{ e.middleTitle }}
            </span>
          </div>
          <div class="buttom_introduce">
            <div class="left_func">
              <div>
                <div>
                  <img :src="e.leftIcon" alt="" class="huiyuankaquanrukou" />
                </div>
                <span class="title">{{ e.leftTitle }}</span>
              </div>
              <span class="describe">{{ e.leftContent }}</span>
            </div>
            <div class="right_func">
              <div>
                <img :src="e.rightIcon" alt="" class="huiyuankaquanrukou" />
                <span class="title">{{ e.rightTitle }}</span>
              </div>
              <span class="describe">{{ e.rightContent }}</span>
            </div>
          </div>
        </div>
        <div class="image_contain" v-if="i % 2 == 0">
          <span class="image_line"></span>
          <img :src="e.phoneOutside" alt="" class="screen" />
          <img :src="e.phnoeContain" alt="" class="img_detail" />
          <img :src="e.phoneMask" alt="" class="shap" />
        </div>
      </div>
    </div>
    <div class="swiper-slide">
      <div class="news">
        <div class="news-left">
          <div class="news-left__title">
            <div class="news-left__title--look">看一看</div>
            <div class="news-left__title--change" @click="changeList">
              ⟳换一批
            </div>
          </div>
          <div class="news-left--content"></div>
        </div>
        <div class="news-right">
          <div class="news-right--title">今日热点</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          topTitle: "中国主流的社交商城系统",
          bigTitle: "满足市场20多种社交商城模式",
          middleTitle:
            "目前:帮您提供在线上做生意做业务的工具，让您在线上实现成交，让电商成为企业增长核心驱动力。",
          leftIcon: require("@/assets/icon/vip-case.png"),
          leftTitle: "社交电商",
          leftContent:
            "根据您的需求匹配现有功能，提供多行业多场景的标准电商系统解决方案。",
          rightIcon: require("@/assets/icon/money.png"),
          rightTitle: "定制开发",
          rightContent:
            "根据客户业务需求，梳理业务流程，为客户制定开发个性化商城系统。",
          phoneOutside: require("@/assets/images/phone.png"),
          phnoeContain: require("@/assets/images/shop1.jpg"),
          phoneMask: require("@/assets/images/phone_mask.png"),
        },
        {
          topTitle: "中国主流的社交商城系统",
          bigTitle: "满足多平台一键开店六网合一",
          middleTitle:
            "微信公众号、小程序、app、支付宝、pc端、wap等多个平台，数据同步，统一管理，全方位引流，聚合流量曝光引流。",
          leftIcon: require("@/assets/icon/gift.png"),
          leftTitle: "微信视频号",
          leftContent:
            "基于微信生态，打通微信视频号等多种功能，可实现视频号拓展链接，视频号直播带货，撬动12亿活跃用户流量。",
          rightIcon: require("@/assets/icon/compnany-wechat.png"),
          rightTitle: "企业微信号",
          rightContent:
            "基于企微管理功能，对接企业微信客服消息通知，实现企业微信群引流，群拓客，群锁客效果，助力企业高效管理。",
          phoneOutside: require("@/assets/images/phone.png"),
          phnoeContain: require("@/assets/images/shop2.png"),
          phoneMask: require("@/assets/images/phone_mask.png"),
        },
        {
          topTitle: "中国主流的社交商城系统",
          bigTitle: "满足多样化业务分润模式",
          middleTitle:
            "完善的分润机制，帮助商家快速裂变推广，助力企业打造“多样化业务模式+高效率成单分润”全网电商平台。",
          leftIcon: require("@/assets/icon/case.png"),
          leftTitle: "推客分红",
          leftContent:
            "等级身份二级分销功能，实现“自购省钱，分享赚钱”的社交电商平台，进入全民带货新时代。",
          rightIcon: require("@/assets/icon/person.png"),
          rightTitle: "拼团分红",
          rightContent:
            "阶梯拼团，拼团奖励，抢团等多种拼团玩法，快速传播裂变，提升拉新效率，占领电商万亿风口。",
          phoneOutside: require("@/assets/images/phone.png"),
          phnoeContain: require("@/assets/images/shop3.png"),
          phoneMask: require("@/assets/images/phone_mask.png"),
        },
      ],
      imgWordList: ['科学', '创新', '共赢', `可依赖`]
    };
  },
  mounted() {},
  methods: {
    changeList() {
      this.$message("暂无更多数据");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
